import { Component, OnInit, Input } from '@angular/core';
import { DeathInstructionsAddEditComponent } from './parts/add-edit/add-edit.component';

@Component({
  selector: 'app-death-instructions',
  templateUrl: './death-instructions.component.html',
  styleUrls: ['./death-instructions.component.scss']
})
export class DeathInstructionsComponent implements OnInit {

  @Input() object: Object;
  @Input() summaryOnly: boolean = false;
  public key: string;
  public extraData: Object;

  constructor() { }

  ngOnInit(): void {

    this.key = 'death-instruction';
    this.extraData = {
      heading: this.object['title']['rendered'],
      component: DeathInstructionsAddEditComponent,
      showSummaryOnly: this.showSummaryOnly(),
      options: {
        class: 'modal-lg'
      },
      section: {
        key: 'death-instruction',
        title: 'Death Instructions',
        type: 'children',
        childType: 'death-instruction',
        plural: 'death instructions',
        singular: 'Death Instructions',
        min: 0,
        max: 0,
      },
    }

  }

  showSummaryOnly() {

    if( typeof( this.object ) === 'undefined' ) {
      return true;
    }

    return this.summaryOnly;

  }

}
